import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { decodeBase64URL, encodeBase64URL } from '../base64url';
import { stringify } from '../../../utils';
import { logTaggedMessage } from '../../reporter';
import { threeDsErrors } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
const log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'adyen-challenge',
});
export const performChallenge = async ({ data: actionData, methodUrl, provider, }) => {
    const challengeDisplaySize = getThreeDsChallengeDisplaySize();
    const { threeDSServerTransID, acsTransID, messageVersion, threeDS2Token } = actionData;
    const dataToServer = {
        token: threeDS2Token,
    };
    const success = () => ({
        challengeData: {
            provider,
            received: {},
            challengeDisplaySize,
            data: dataToServer,
        },
    });
    const fail = (error) => {
        return {
            challengeData: {
                challengeDisplaySize,
                provider,
                notReceived: { error },
                data: dataToServer,
            },
        };
    };
    const requestData = {
        challengeWindowSize: getAdyenChallengeSize(),
        acsTransID,
        threeDSServerTransID,
        messageVersion,
        messageType: 'CReq',
    };
    const requestRawPostData = encodeRequestData(requestData);
    const logData = {
        actionData,
        methodUrl,
        provider,
        challengeDisplaySize,
        dataToServer,
        requestData,
        requestRawPostData,
    };
    log('3ds: before render 3ds Adyen challenge iframe', logData);
    if (!methodUrl) {
        const ret = fail(threeDsErrors.missingUrl('ADYEN', 'challenge'));
        log(`3ds: Adyen Device Challenge failed`, { ...logData, ret });
        return ret;
    }
    const resultPromise = renderIframeAndWaitForPostback('visible', methodUrl, 'POST', requestRawPostData).then(parseChallengePostData);
    try {
        const challengeResult = await resultPromise;
        if (challengeResult.threeDSServerTransID !== threeDSServerTransID) {
            const err = `Adyen challengeResult transactionId dont match!
      sent: ${threeDSServerTransID},
      recived: ${challengeResult.threeDSServerTransID}`;
            const ret = fail(err);
            log(`3ds: Adyen Challenge failed`, { ...logData, err, ret });
            return ret;
        }
        log('3ds: received Adyen Challenge success', {
            ...logData,
            challengeResult,
        });
        return success();
    }
    catch (e) {
        const ret = fail(threeDsErrors.generate3dsError({
            providerFlow: 'ADYEN',
            step: 'challenge',
            e,
        }));
        log(`3ds: Adyen Challenge failed`, { ...logData, ret, e });
        return ret;
    }
    finally {
        removeChallengeIframe();
    }
};
const encodeRequestData = (data) => {
    const encodedData = encodeBase64URL(JSON.stringify(data));
    const fields = {
        creq: encodedData,
    };
    return fields;
};
const parseChallengePostData = (postData) => {
    if (typeof postData !== 'object' ||
        !postData.cres) {
        throw new ThreeDsFormattingException(`invalid ChallengeResponseRawPostData: (${postData}) ${stringify(postData)}`);
    }
    let decoded;
    try {
        decoded = decodeBase64URL(postData.cres);
    }
    catch (e) {
        throw new ThreeDsFormattingException(`failed to decode invalid ChallengeResponseRawPostData.cres: ${stringify(postData)}`);
    }
    let parsedObj;
    try {
        parsedObj = JSON.parse(decoded);
    }
    catch (e) {
        throw new ThreeDsFormattingException(`failed to JSON parse invalid decoded ChallengeResponseRawPostData.cres: ${decoded}`);
    }
    if (typeof parsedObj.threeDSServerTransID !== 'string' ||
        parsedObj.transStatus !== 'Y') {
        throw new ThreeDsFormattingException(`invalid ChallengeResponseData: ${decoded}`);
    }
    return parsedObj;
};
const threeDsChallengeSizeToAdyenChallengeSize = (_size) => {
    const width = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    const adyenChallengeWindowSize = width > 600
        ? '05'
        : width > 500
            ? '04'
            : width > 390
                ? '03'
                : width > 250
                    ? '02'
                    : '01';
    return adyenChallengeWindowSize;
};
const getAdyenChallengeSize = () => threeDsChallengeSizeToAdyenChallengeSize(getThreeDsChallengeDisplaySize());
//# sourceMappingURL=adyen-challenge.js.map